import React from 'react';
import {connect, useSelector} from 'react-redux';
import {push} from 'connected-react-router';
import SMPLayout from '../../components/MainComponents/SMPLayout';
import SMPMainHeader from '../../components/MainComponents/SMCMainHeader'
import SMPMainSidebar from '../../components/MainComponents/SMPMainSidebar';
import SMPMainFooter from '../../components/MainComponents/SMCMainFooter';
import SMPMainBody from '../../components/MainComponents/SMCMainBody';
import {SMCPaths} from '../../conf/Routes';
import IdleHandler from '../IdleHandler';
import {isAuthenticatedSelector} from '../../store/selectors/user.selectors';

/**
 * This is above the whole site, if the user is not authenticated,
 * redirect to login, otherwise show the site.
 */
function ProtectedHandler({
    navigateTo
}) {
    const isAuth = useSelector(isAuthenticatedSelector);
    if (!isAuth) {
        navigateTo(SMCPaths.login);
    }
    return (
        <>
        <IdleHandler />
        <SMPLayout
            Header={SMPMainHeader}
            Sidebar={SMPMainSidebar}
            Body={SMPMainBody}
            Footer={SMPMainFooter}
        />
        </>
    );
}

const mapStateToProps = null;

const mapDispatchToProps = {
    navigateTo: push,
}

export default connect(mapStateToProps, mapDispatchToProps)(ProtectedHandler);